module.exports = __webpack_public_path__ + "img/baipei5.8724f091.jpg";